import { useEffect, useState } from 'react'
import { Alert, CircularProgress, Grid, Typography } from '@mui/material'

import Api from '../../utils/api'
import useDates from '../../utils/hooks/useDates'
import FullScreenModal from '../full-screen-modal'

import useStyles from './index.styles'

interface IProps {
  isOpen: boolean
  onClose: () => void
  folderId: number
}

interface IAccountDetails {
  accountNumber: string
  agreementSignedBy: string
  agreementSignedDate: string
  installOption: string
  status: string
}

const AccountDetailsModal = (props: IProps) => {
  const { isOpen, onClose, folderId } = props

  const classes = useStyles
  const { formatDate } = useDates()

  const [accountDetails, setAccountDetails] = useState<IAccountDetails | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const formatAgreementDate = (dateString: string | null | undefined): string => {
    if (!dateString) {
      return 'No Date on file'
    }
    return formatDate(dateString)
  }

  useEffect(() => {
    if (folderId) {
      setLoading(true)
      Api.get(`/api/v2/protect/folders/${folderId}/account-details`).then((res) => {
        setLoading(false)
        if (res.ok) {
          setAccountDetails(res.body)
        } else {
          setError('Could not load account details')
        }
      })
    }
  }, [folderId])

  return (
    <FullScreenModal open={isOpen} onClose={onClose} title="Account Details" showCloseIcon={true} maxWidth="sm" confirmLabel="Close" onConfirm={onClose}>
      <Grid container={true} spacing={0}>
        {loading && !error && !accountDetails && (
          <Grid>
            <CircularProgress />
          </Grid>
        )}

        {!loading && error && !accountDetails && (
          <Grid>
            <Alert severity="error">{error}</Alert>
          </Grid>
        )}

        {!loading && !error && accountDetails && (
          <>
            <Grid container={true} spacing={0} sx={classes.accountDetailsBox}>
              <Grid size={6}>
                <Typography variant="body2">Account</Typography>
              </Grid>

              <Grid size={6}>
                <Typography variant="body2" sx={classes.statusValue}>
                  {accountDetails.status}
                </Typography>
              </Grid>

              {accountDetails.accountNumber && (
                <Grid size={12} sx={classes.largeText}>
                  <Typography variant="body1">Account # {accountDetails.accountNumber}</Typography>
                </Grid>
              )}

              <Grid size={12}>
                <Typography variant="body2">Participant Agreement signed by:</Typography>
              </Grid>

              <Grid size={12}>
                <Typography variant="body2">
                  {accountDetails.agreementSignedBy} ({formatAgreementDate(accountDetails.agreementSignedDate)})
                </Typography>
              </Grid>
            </Grid>

            {accountDetails.installOption && (
              <Grid container={true} spacing={0} sx={classes.installTypeBox}>
                <Grid size={12}>
                  <Typography variant="body2">Install Type</Typography>
                </Grid>

                <Grid size={12} sx={classes.largeText}>
                  <Typography variant="body1">{accountDetails.installOption.charAt(0).toUpperCase() + accountDetails.installOption.slice(1)}</Typography>
                </Grid>
              </Grid>
            )}
          </>
        )}
      </Grid>
    </FullScreenModal>
  )
}

export default AccountDetailsModal
